// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".provider-proposal-callout[data-v-1a7c3642] .callout-container {\n  border: none !important;\n  background-color: white;\n  padding-left: 25px;\n}\n.legend[data-v-1a7c3642] {\n  font-weight: 400;\n}\n.text-black[data-v-1a7c3642] {\n  color: #11291b;\n}", ""]);
// Exports
module.exports = exports;
